import {
  EstadosAgendamientoEnumChoice,
  EstadosOrdenTrabajoEnumChoice,
  EstadosPreagendamientoEnumChoice,
} from '../constants';
import { EstadosPreagendamientoCodigoEnum } from '../interfaces';

export const calcColorStatePreAgenda = (
  estdo_pil: EstadosPreagendamientoCodigoEnum
) => {
  switch (estdo_pil) {
    case EstadosPreagendamientoCodigoEnum.ESPERA:
      return 'blue';
    case EstadosPreagendamientoCodigoEnum.APROBADO:
    case EstadosPreagendamientoCodigoEnum.FINALIZADO:
      return 'green';
    case EstadosPreagendamientoCodigoEnum.RECHAZADO:
      return 'red';
    case EstadosPreagendamientoCodigoEnum.PENDIENTE_REAGENDAR:
      return 'blue';
    case EstadosPreagendamientoCodigoEnum.PAUSADO:
      return 'orange';
    // no se visualiza en la tabla - sus agendas
    case EstadosPreagendamientoCodigoEnum.REAGENDADO:
      return 'green';
    default:
      return 'blue';
  }
};

export const calcStateTextPreAgenda = (
  estdo_pil: EstadosPreagendamientoEnumChoice
) => {
  switch (estdo_pil) {
    case EstadosPreagendamientoEnumChoice.EN_ESPERA:
      return 'EN ESPERA';
    case EstadosPreagendamientoEnumChoice.APROBADO:
    case EstadosPreagendamientoEnumChoice.FINALIZADO:
      return 'APROBADO';
    case EstadosPreagendamientoEnumChoice.RECHAZADO:
      return 'REQUIRE ACTUALIZACIÓN';
    case EstadosPreagendamientoEnumChoice.PENDIENTE_REAGENDAR:
      return 'PENDIENTE REVISIÓN';
    case EstadosPreagendamientoEnumChoice.EN_PAUSA:
      return 'EN PAUSA';
    // no se visualiza en la tabla - sus agendas
    case EstadosPreagendamientoEnumChoice.REAGENDADO:
      return 'REAGENDADO';
    default:
      return 'ESPERA';
  }
};

export const calcColorStateOrdenTrabajoNew = (stateCode: string) => {
  const colorMap: Record<string, string> = {
    [EstadosOrdenTrabajoEnumChoice.EN_ESPERA]: 'blue',
    [EstadosOrdenTrabajoEnumChoice.ESPERA_RECOORDINADA]: 'blue',
    [EstadosOrdenTrabajoEnumChoice.REALIZADA]: 'green',
    [EstadosOrdenTrabajoEnumChoice.PRE_RECHAZADO]: 'red',
    [EstadosOrdenTrabajoEnumChoice.RECHAZADA]: 'red',
  };

  return colorMap[stateCode] || 'inherit';
};

export const calcColorStateAgendamiento = (stateCode: string) => {
  const colorMap: Record<string, string> = {
    [EstadosAgendamientoEnumChoice.EN_ESPERA]: 'blue',
    [EstadosAgendamientoEnumChoice.GESTION_VENTA]: 'purple',
    [EstadosAgendamientoEnumChoice.FINALIZADO]: 'green',
    [EstadosAgendamientoEnumChoice.PRERECHAZADO]: 'orange',
    [EstadosAgendamientoEnumChoice.CANCELADO]: 'red',
  };

  return colorMap[stateCode] || 'inherit';
};


const statusAuditoriaLog: Record<string, string> = {
  ['crear']: 'success',
  ['actualizar']: 'info',
  ['actualizar_parcial']: 'warning',
  ['eliminar']: 'error',
  ['consultar']: 'primary',
  ['login']: 'success',
  ['logout']: 'warning',
}

const statusGeneral: Record<string, string> = {
  ['EN ESPERA']: '#0046FF',
  ['EN PROCESO']: 'orange',
  ['EN PAUSA']: 'orange',
  ['ABIERTO']: 'orange',
  ['EN GESTION']: 'orange',
  ['FINALIZADO']: 'green',
  ['APROBADO']: 'green',
  ['CANCELADO']: 'red',
  ['FALLIDO']: 'red',
  ['PRE RECHAZADO']: 'red',
  ['RECHAZADO']: 'red',
  ['PENDIENTE']: '#007bff',
  ['EN REVISION']: 'gray',
  ['TRASLADO_EN_ESPERA']: 'info',

}

function createColorCalculator<T extends string>(
  map: Record<T, string>,
  defaultColor = "#0046FF",
) {
  return (estado: T): string => map[estado] ?? defaultColor;
}


function createColorCalculatorMaterialUI<T extends string>(
  map: Record<T, string>,
  defaultColor = "info",
) {
  return (estado: T): string => map[estado] ?? defaultColor;
}

export const calcColorStatusGeneral = createColorCalculator(statusGeneral);
export const calcColorStatusAuditoriaLog = createColorCalculatorMaterialUI(statusAuditoriaLog);

// FIX crash "undefined.contrastText": MUI Chip color= solo acepta claves de paleta (no 'orange'/'green'/hex). Mapa traducido:
const statusGeneralMUI: Record<string, string> = {
  ['EN ESPERA']: 'primary', ['EN PROCESO']: 'warning', ['EN PAUSA']: 'warning', ['ABIERTO']: 'warning',
  ['EN GESTION']: 'warning', ['FINALIZADO']: 'success', ['APROBADO']: 'success', ['CANCELADO']: 'error',
  ['FALLIDO']: 'error', ['PRE RECHAZADO']: 'error', ['RECHAZADO']: 'error', ['PENDIENTE']: 'info',
  ['EN REVISION']: 'default', ['TRASLADO_EN_ESPERA']: 'info', ['REVERSAR']: 'warning'
};
export const calcColorCalculatorMaterialUI = createColorCalculatorMaterialUI(statusGeneralMUI);
